import { useMemo } from 'react';
import { SEARCH_QUERY as PUBLIC_SEARCH_QUERY } from '../../../__generated__/chirp/com/hubspot/marketplace/personalization/rpc/PersonalizationPublicRpc.dfc.new';
import {
  Filter,
  FilterQuery,
} from '../../../__generated__/chirp/com/hubspot/marketplace/personalization/rpc/PersonalizationRpc';
import { SEARCH_QUERY } from '../../../__generated__/chirp/com/hubspot/marketplace/personalization/rpc/PersonalizationRpc.dfc.new';
import { usePersonalizationQuery } from '../../hooks/usePersonalizationQuery';
import { DATA_TYPE_MAP } from '../../search-results/utils/searchMappers';

export function useGetPartnerCount(
  selectedServices: string[] = [],
  selectedIndustries: string[] = [],
  selectedCountry: string | null = null,
  requireOfficeInCountry = false,
  selectedLanguages: string[] = []
) {
  const countFilter = useMemo((): Filter => {
    const filtersByField: Record<string, FilterQuery[]> = {
      PRODUCT_TYPE: [
        {
          values: ['SOLUTIONS_PARTNER_PROFILE'],
          negation: false,
          clause: 'OR',
          __typename: DATA_TYPE_MAP.STRING,
        } as FilterQuery,
      ],
    };

    if (selectedServices.length > 0) {
      filtersByField.PROFILE_CATALOG_SERVICES = [
        {
          values: selectedServices.map(Number),
          negation: false,
          clause: 'OR',
          __typename: DATA_TYPE_MAP.LONG,
        } as FilterQuery,
      ];
    }

    if (selectedIndustries.length > 0) {
      filtersByField.PROFILE_INDUSTRIES = [
        {
          values: selectedIndustries,
          negation: false,
          clause: 'OR',
          __typename: DATA_TYPE_MAP.STRING,
        } as FilterQuery,
      ];
    }

    if (selectedCountry) {
      filtersByField.PROFILE_LOCATION_COUNTRY = [
        {
          values: [selectedCountry],
          negation: false,
          clause: 'OR',
          __typename: DATA_TYPE_MAP.STRING,
        } as FilterQuery,
      ];
    }

    if (requireOfficeInCountry && selectedCountry) {
      filtersByField.PROFILE_OFFICE_LOCATION = [
        {
          values: [selectedCountry],
          negation: false,
          clause: 'OR',
          __typename: DATA_TYPE_MAP.STRING,
        } as FilterQuery,
      ];
    }

    if (selectedLanguages.length > 0) {
      filtersByField.PROFILE_LANGUAGES = [
        {
          values: selectedLanguages,
          negation: false,
          clause: 'OR',
          __typename: DATA_TYPE_MAP.STRING,
        } as FilterQuery,
      ];
    }

    return {
      filterGroups: [{ filtersByField, clause: 'AND', negation: false }],
      clause: 'AND',
      negation: false,
    };
  }, [
    requireOfficeInCountry,
    selectedCountry,
    selectedLanguages,
    selectedIndustries,
    selectedServices,
  ]);

  const { data: countData, previousData } = usePersonalizationQuery({
    app: SEARCH_QUERY,
    public: PUBLIC_SEARCH_QUERY,
    options: {
      variables: {
        filter: countFilter,
        length: 0,
        offset: 0,
      },
    },
  });

  return (countData ?? previousData)?.result?.total ?? 0;
}
